import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  StateService,
  ToolService,
  RouterService,
  Machine,
  Inspection,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';
import {
  INSPECTION_GROUPS,
  InspectionGroup,
} from '../../models/inspection-group';
import { ModalRole } from '../../models/modal-roles';

@Component({
  selector: 'lib-inspection-form',
  templateUrl: './inspection-form.component.html',
  styleUrls: ['./inspection-form.component.scss'],
  standalone: false,
})
export class InspectionFormComponent implements OnInit {
  constructor(
    public state: StateService,
    public tools: ToolService,
    private route: ActivatedRoute,
    public routerService: RouterService,
    public modalCtrl: ModalController
  ) {}

  INSPECTION_GROUPS: InspectionGroup[] = INSPECTION_GROUPS;
  subs: Subscription[] = [];
  paramId: string;
  machines: Machine[] = [];
  newInspection: Inspection = {};
  allInspections: Inspection[] = [];
  selectedMachine: Machine;
  inspectionError: boolean = true;

  ngOnInit() {
    this.subs.push(
      this.state.machines$.subscribe(
        (x) => (this.machines = x.filter((y) => !y.inspectionFree))
      )
    );
    if (this.paramId) {
      this.subs.push(
        this.state.inspections$.subscribe((x) => {
          this.allInspections = x;
          this.newInspection = x.find((y) => y.id == this.paramId);
          if (this.newInspection != null) this.inspectionError = false;
        })
      );
    } else {
      this.subs.push(
        this.state.inspections$.subscribe((x) => {
          this.allInspections = x;
        })
      );
      this.newInspection.machineId = '';
      this.initNewForm();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => {
      x.unsubscribe();
    });
  }

  takeLastInspectionAsTemplate() {
    const newestItem = this.allInspections
      .filter((item) => item.machineId === this.selectedMachine.id)
      .reduce((a, b) => (a.dateUtc > b.dateUtc ? a : b));
    this.newInspection = JSON.parse(JSON.stringify(newestItem));
    this.newInspection.id = '';
    this.newInspection.dateUtc = null;
  }

  selectedMachineChanged(id: string) {
    this.inspectionError = false;
    this.newInspection.machineId = id;
    this.selectedMachine = this.machines.find((x) => x.id == id);
  }

  public cancel() {
    return this.modalCtrl.dismiss(null, ModalRole.Cancel);
  }

  removeKey(key: string) {
    delete this.newInspection.inspectionResults[key];
  }

  dateChanged(evt: string) {
    this.newInspection.dateUtc = evt;
  }

  groupHasElements(group: InspectionGroup): boolean {
    let hasElements = false;
    group.inspectionElements.forEach((x) => {
      if (this.newInspection.inspectionResults[x.name] != null)
        hasElements = true;
    });
    return hasElements;
  }

  initNewForm() {
    this.newInspection.id = '';
    this.newInspection.operatingHours = '';
    this.newInspection.notes = '';
    this.newInspection.inspectionResults = {};
    this.INSPECTION_GROUPS.forEach((x) => {
      x.inspectionElements.forEach((y) => {
        this.newInspection.inspectionResults[y.name] = {
          description: '',
          success: true,
        };
      });
    });
  }

  async create() {
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.createInspection(this.newInspection);
  }

  async update() {
    await this.modalCtrl.dismiss(null, 'confirm');
    this.state.updateInspection(this.newInspection);
  }
}
